/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pie': {
    width: 16,
    height: 16,
    viewBox: '0 0 18.8 18.8',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M9.14 18.8A9.14 9.14 0 016.6.89a.5.5 0 11.28 1 8.14 8.14 0 1010 10.24.5.5 0 011 .3 9.1 9.1 0 01-8.74 6.37z" _fill="#c4c4c4"/><path pid="1" d="M18.8 9.67A9.67 9.67 0 009.14 0v9.67z" _fill="#74777a"/></g></g>'
  }
})
